import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.regexp.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Entry from 'src/store/models/Entry';
import User from 'src/store/models/User';
import Group from 'src/store/models/Group';
import Phase from 'src/store/models/Phase';
import Client from 'src/store/models/Client';
import Project from 'src/store/models/Project';
import PhaseCategory from 'src/store/models/PhaseCategory';
import Tag from 'src/store/models/Tag';
import TagList from 'src/store/models/TagList';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
import EntryDetail from "./Entity";
import EntityPicker from 'src/components/Pickers/Picker';
import BillableStatusPicker from 'src/components/Pickers/BillableStatus';
import Timeframe from 'src/components/Pickers/Timeframe';
import Vue from 'vue';
import moment from 'moment';
import { timeframeUtils } from 'src/boot/mixins';
import { map, isNil, merge, toUpper, findIndex, find, forEach, isObject, cloneDeep, orderBy, uniq, uniqBy, reduce, debounce } from 'lodash';
export default {
  mixins: [timeframeUtils],
  props: {
    initialFilters: {
      type: Object,
      default: null
    },
    isPage: {
      type: Boolean,
      default: false
    },
    canAddTime: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EntryDetail: EntryDetail,
    EntityPicker: EntityPicker,
    Timeframe: Timeframe,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade,
    BillableStatusPicker: BillableStatusPicker
  },
  data: function data() {
    var defaultFilters = {
      time_frame: 'all',
      date_from: null,
      date_to: null,
      billed_status: null,
      text: ''
    };

    if (!isNil(this.initialFilters)) {
      merge(defaultFilters, this.initialFilters);
    }

    return {
      entries: [],
      filters: defaultFilters,
      updatedParams: {
        delete_selected: false,
        billed_status: null,
        member_id: null,
        project_id: null,
        phase_id: null,
        hourly_cost: null,
        hourly_rate: null
      },
      page: 1,
      totalEntries: 0,
      entriesStats: {},
      loading: true,
      overwrite: true,
      selectAllEntries: false,
      showFilters: false,
      showAdvancedFilters: false,
      selectionData: [],
      visibleChildrenEntryIds: [],
      billedOptions: [{
        value: null,
        label: this.$t('components.entries.any_state')
      }, {
        value: 0,
        label: this.$t('general.unbilled')
      }, {
        value: 1,
        label: this.$t('general.billed')
      }, {
        value: 2,
        label: this.$t('general.not_billable')
      }, {
        value: 3,
        label: this.$t('general.billable')
      }],
      billedUpdateOptions: [{
        value: 0,
        label: this.$t('components.entries.set_as_unbilled')
      }, {
        value: 1,
        label: this.$t('components.entries.set_as_billed')
      }, {
        value: 2,
        label: this.$t('components.entries.set_as_not_billable')
      }]
    };
  },
  watch: {
    selectAllEntries: function selectAllEntries() {
      var _this = this;

      this.selectionData = [];
      this.entries.forEach(function (entry) {
        if (Entry.isEditable(entry, _this.me)) {
          entry.selected = _this.selectAllEntries;

          _this.updateSelected(_this.selectAllEntries, entry, false);
        }
      });
    }
  },
  computed: {
    cardStyle: function cardStyle() {
      return !this.isPage ? 'width: 600px; overflow: hidden' : '';
    },
    entriesContainerStyle: function entriesContainerStyle() {
      var headerHeight = 0;
      var footerHeight = 0;

      if (this.isPage) {
        var _this$$refs$pageHead, _this$$refs$pageHead2, _document$getElementB, _document$getElementB2;

        headerHeight = (_this$$refs$pageHead = (_this$$refs$pageHead2 = this.$refs['page-header']) === null || _this$$refs$pageHead2 === void 0 ? void 0 : _this$$refs$pageHead2.clientHeight) !== null && _this$$refs$pageHead !== void 0 ? _this$$refs$pageHead : 0;
        footerHeight = (_document$getElementB = (_document$getElementB2 = document.getElementById('app-footer')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.getBoundingClientRect().height) !== null && _document$getElementB !== void 0 ? _document$getElementB : 0;
      } else {
        var _this$$refs$dialogHe, _this$$refs$dialogHe2, _this$$refs$dialogFo, _this$$refs$dialogFo2;

        headerHeight = (_this$$refs$dialogHe = (_this$$refs$dialogHe2 = this.$refs['dialog-header']) === null || _this$$refs$dialogHe2 === void 0 ? void 0 : _this$$refs$dialogHe2.$el.clientHeight) !== null && _this$$refs$dialogHe !== void 0 ? _this$$refs$dialogHe : 0;
        footerHeight = (_this$$refs$dialogFo = (_this$$refs$dialogFo2 = this.$refs['dialog-footer']) === null || _this$$refs$dialogFo2 === void 0 ? void 0 : _this$$refs$dialogFo2.$el.clientHeight) !== null && _this$$refs$dialogFo !== void 0 ? _this$$refs$dialogFo : 0;
      }

      if (this.isMounted) {
        if (this.isMobile) {
          return "width: 100vw; height: calc(var(--vh, 1vh) * 100 - ".concat(headerHeight, "px - ").concat(footerHeight, "px)");
        } else {
          return "".concat(!this.isSmallScreen ? 'width: 600px;' : '', " height: 800px; max-height: calc(var(--vh, 1vh) * 100 - ").concat(headerHeight, "px - ").concat(footerHeight + 30, "px - 50px)");
        }
      }

      return 0;
    },
    dateFormat: function dateFormat() {
      return toUpper(this.me.settings.dateFormat);
    },
    entriesByDate: function entriesByDate() {
      var entriesByDate = []; //

      var entriesGroups = this.entries.map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          hash: Entry.groupingHash(e)
        });
      }).reduce(function (acc, entry) {
        // Check if in the acc, there is already an entry with the same groupingHash
        var hash = entry.hash;

        if (acc[hash]) {
          // If it exists, then add the entry_minutes, cost, revenue and profit to the existing entry
          acc[hash].entryGroup.push(entry);
          acc[hash].entry_minutes = parseInt(acc[hash].entry_minutes) + parseInt(entry.entry_minutes);
          acc[hash].cost = parseFloat(acc[hash].cost) + parseFloat(entry.cost);
          acc[hash].revenue = parseFloat(acc[hash].revenue) + parseFloat(entry.revenue);
          acc[hash].profit = parseFloat(acc[hash].profit) + parseFloat(entry.profit);
          acc[hash].entry_id = acc[hash].entryGroup.map(function (e) {
            return "".concat(e.entry_id);
          }).join('-');
        } else {
          // If it doesn't exist, then add the entry to the acc
          acc[hash] = _objectSpread(_objectSpread({}, entry), {}, {
            entryGroup: [_objectSpread({}, entry)],
            selected: null
          });
        }

        return acc;
      }, []);
      Object.values(entriesGroups).map(function (group) {
        // If all the entries in the group are selected, then set the group as selected
        // If some of the entries are selected, then set the group selected as null
        // If none of the entries are selected, then set the group as not selected
        var selected = group.entryGroup.every(function (e) {
          return e.selected;
        }) ? true : group.entryGroup.some(function (e) {
          return e.selected;
        }) ? null : false; // Use moment to parse time_from and time_to of each entry in the group.
        // get the minimum time_from and maximum time_to to get the time range of the group

        var timeFrom = moment.min(group.entryGroup.map(function (e) {
          return moment(e.time_from);
        }));
        var timeTo = moment.max(group.entryGroup.map(function (e) {
          return moment(e.time_to);
        }));
        return _objectSpread(_objectSpread({}, group), {}, {
          selected: selected,
          time_from: timeFrom,
          time_to: timeTo
        });
      }).forEach(function (entry) {
        var dateIndex = findIndex(entriesByDate, ['date', entry.entry_date]);

        if (dateIndex === -1) {
          entriesByDate.push({
            entries: [],
            date: entry.entry_date,
            totalTime: 0
          });
          dateIndex = entriesByDate.length - 1;
        }

        entriesByDate[dateIndex].entries.push(entry);
        entriesByDate[dateIndex].totalTime += entry.entry_minutes;
      });
      return entriesByDate;
    },
    humanReadableFilters: function humanReadableFilters() {
      return {
        timeframe: this.timeFrameHumanReadableFilter,
        team_member: this.filters.member_ids ? this.usersHumanReadableFilter : [],
        project: this.filters.project_ids ? this.projectsHumanReadableFilter : [],
        phase: this.filters.phase_ids ? this.phasesHumanReadableFilter : [],
        client: this.filters.client_ids ? this.clientsHumanReadableFilter : [],
        billing_status: this.billedHumanReadableFilter,
        group: this.filters.group_ids ? this.groupsHumanReadableFilter : [],
        tag_lists: this.filters.tag_list_ids ? this.tagListsHumanReadableFilter : [],
        phase_category: this.filters.category_ids ? this.phaseCategoriesHumanReadableFilter : [],
        tag: this.filters.tag_ids ? this.tagsHumanReadableFilter : [],
        notes_and_integration_info: this.filters.text ? [this.filters.text] : []
      };
    },
    editProjectFilters: function editProjectFilters() {
      return {
        user_id: this.updatedParams.member_id && this.updatedParams.member_id > 0 ? this.updatedParams.member_id : this.sanitizedSelectedUsers,
        active: 1
      };
    },
    editPhaseParentId: function editPhaseParentId() {
      if (this.sanitizedSelectedProjects.length === 1 && (!this.updatedParams.project_id || this.updatedParams.project_id < 0)) {
        return this.sanitizedSelectedProjects[0];
      }

      return this.updatedParams.project_id;
    },
    editMemberFilters: function editMemberFilters() {
      var filters = {// active: 1
      };

      if (this.updatedParams.project_id > 0) {
        filters.project_id = this.updatedParams.project_id;
      } else {
        filters.project_ids = this.sanitizedSelectedProjects;
      }

      return filters;
    },
    showHumanReadableFilters: function showHumanReadableFilters() {
      var _this2 = this;

      return Object.keys(this.humanReadableFilters).reduce(function (sum, key) {
        return sum + _this2.humanReadableFilters[key].length;
      }, 0);
    },
    groupsHumanReadableFilter: function groupsHumanReadableFilter() {
      var _this3 = this;

      var filter = [];

      if (!isNil(this.filters.group_ids)) {
        forEach(this.filters.group_ids, function (groupId) {
          var localGroup = Group.find(groupId);
          filter.push(localGroup ? localGroup.name : _this3.$t('components.entries.without_group'));
        });
      }

      return filter;
    },
    projectsHumanReadableFilter: function projectsHumanReadableFilter() {
      var _this4 = this;

      var filter = [];

      if (!isNil(this.filters.project_ids) && this.filters.project_ids.length > 0) {
        forEach(this.filters.project_ids, function (projectId) {
          var project = Project.find(projectId);

          if (project) {
            filter.push(_this4.stripTags(project.name));
          }
        });
      }

      return filter;
    },
    clientsHumanReadableFilter: function clientsHumanReadableFilter() {
      var _this5 = this;

      var filter = [];

      if (!isNil(this.filters.client_ids) && this.filters.client_ids.length > 0) {
        forEach(this.filters.client_ids, function (clientId) {
          var localClient = Client.find(clientId);
          filter.push(localClient ? localClient.name : _this5.$t('components.entries.without_client'));
        });
      }

      return filter;
    },
    usersHumanReadableFilter: function usersHumanReadableFilter() {
      var _this6 = this;

      var filter = [];

      if (!isNil(this.filters.member_ids) && this.filters.member_ids.length > 0) {
        forEach(this.filters.member_ids, function (userId) {
          var user = User.find(userId); // If it's me, then set me as name

          if (user.user_id === _this6.me.user_id) {
            filter.push(_this6.$t('general.me'));
          } else {
            filter.push(_this6.stripTags(user.name));
          }
        });
      }

      return filter;
    },
    phasesHumanReadableFilter: function phasesHumanReadableFilter() {
      var _this7 = this;

      var filter = [];

      if (!isNil(this.filters.phase_ids) && this.filters.phase_ids.length > 0) {
        forEach(this.filters.phase_ids, function (taskId) {
          var task = Phase.find(taskId);

          if (task) {
            filter.push(_this7.stripTags(task.name));
          }
        });
      }

      return filter;
    },
    phaseCategoriesHumanReadableFilter: function phaseCategoriesHumanReadableFilter() {
      var _this8 = this;

      var filter = [];

      if (!isNil(this.filters.category_ids)) {
        forEach(this.filters.category_ids, function (taskCategoryId) {
          var localCategory = PhaseCategory.find(taskCategoryId);
          filter.push(localCategory ? _this8.stripTags(localCategory.name) : _this8.$t('components.entries.without_category'));
        });
      }

      return filter;
    },
    tagsHumanReadableFilter: function tagsHumanReadableFilter() {
      var _this9 = this;

      var filter = [];

      if (!isNil(this.filters.tag_ids) && this.filters.tag_ids.length > 0) {
        forEach(this.filters.tag_ids, function (tagId) {
          var localTag = Tag.find(tagId);
          filter.push(localTag ? _this9.stripTags(localTag.name) : _this9.$t('components.entries.without_tag'));
        });
      }

      return filter;
    },
    tagListsHumanReadableFilter: function tagListsHumanReadableFilter() {
      var _this10 = this;

      var filter = [];

      if (!isNil(this.filters.tag_list_ids)) {
        forEach(this.filters.tag_list_ids, function (tagListId) {
          var localTaglist = TagList.find(tagListId);
          filter.push(localTaglist ? _this10.stripTags(localTaglist.name) : _this10.$t('components.entries.without_tag_list'));
        });
      }

      return filter;
    },
    timeFrameHumanReadableFilter: function timeFrameHumanReadableFilter() {
      var result = [];

      if (this.filters.time_frame && this.filters.time_frame !== 'all') {
        var filter = this.getReadableTimeframe(this.filters.time_frame);

        if (this.filters.time_frame === 'custom') {
          filter = '';

          if (this.filters.date_from && this.filters.date_from.replace(/_/g, '').length === 10) {
            if (!this.filters.date_to || this.filters.date_to !== this.filters.date_from) {
              filter += 'from ';
            }

            filter += "".concat(this.filters.date_from);
          }

          if (this.filters.date_to && this.filters.date_to !== this.filters.date_from && this.filters.date_to.replace(/_/g, '').length === 10) {
            if (filter.length > 0) {
              filter += ' ';
            }

            filter += "to ".concat(this.filters.date_to);
          }
        }

        if (filter.length > 0) {
          result.push(filter);
        }
      }

      return result;
    },
    billedHumanReadableFilter: function billedHumanReadableFilter() {
      var filter = [];

      if (!isNil(this.filters.billed_status) && this.filters.billed_status >= 0) {
        var option = find(this.billedOptions, ['value', this.filters.billed_status]);

        if (option) {
          filter = [option.label];
        }
      }

      return filter;
    },
    sanitizedSelectedUsers: function sanitizedSelectedUsers() {
      return uniq(map(this.selectionData, 'userId'));
    },
    sanitizedSelectedProjects: function sanitizedSelectedProjects() {
      return uniq(map(this.selectionData, 'projectId'));
    },
    sanitizedSelectedTime: function sanitizedSelectedTime() {
      return reduce(map(this.selectionData, 'time'), function (sum, time) {
        return sum + time;
      }, 0);
    },
    sanitizedSelectedEntries: function sanitizedSelectedEntries() {
      return map(this.selectionData, 'entryId');
    },
    hasSelectedBillableEntries: function hasSelectedBillableEntries() {
      return reduce(map(this.selectionData, 'isBillable'), function (status, billable) {
        return status && billable;
      }, true);
    },
    canEditBillableEntries: function canEditBillableEntries() {
      var _this11 = this;

      return this.me.is_admin || reduce(map(this.selectionData, 'projectId'), function (status, projectId) {
        return Project.$isUserPM(projectId, _this11.me.user_id) && status;
      }, true);
    }
  },
  methods: {
    search: debounce(function () {
      this.loadEntries();
    }, 1000),
    openRegisterTimeDialog: function openRegisterTimeDialog() {
      this.openDialog('RegisterTimeDialog', {
        date: this.initialFilters.date_from === this.initialFilters.date_to ? this.initialFilters.date_from : null,
        projectId: this.initialFilters.project_ids && this.initialFilters.project_ids.length === 1 ? this.initialFilters.project_ids[0] : null
      });
    },
    exportXLSX: function exportXLSX() {
      var _this12 = this;

      var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.me.account.hasFeatureAccess('csv_exports')) {
        if (selected) {
          this.$refs.upgradeXlsMultiple.showTooltip();
        } else {
          this.$refs.upgradeXls.showTooltip();
        }

        return;
      }

      this.$q.loading.show();
      this.$axios.post('entries/export-data', _objectSpread({}, this.getExportParams(selected, 'xlsx')), {
        headers: {
          Accept: 'application/vnd.ms-excel'
        },
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this12.$q.loading.hide();

        var url = URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'entries.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch(function () {
        _this12.$q.loading.hide();

        _this12.$q.notify(_this12.$t('components.entries.error_exporting_file', {
          el: _this12.$t('files.xlsx')
        }));
      });
    },
    exportCSV: function exportCSV() {
      var _this13 = this;

      var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.me.account.hasFeatureAccess('csv_exports')) {
        if (selected) {
          this.$refs.upgradeCsvMultiple.showTooltip();
        } else {
          this.$refs.upgradeCsv.showTooltip();
        }

        return;
      }

      this.$q.loading.show();
      this.$axios.post('entries/export-data', _objectSpread({}, this.getExportParams(selected, 'csv')), {
        headers: {
          Accept: 'text/csv'
        },
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this13.$q.loading.hide();

        var url = URL.createObjectURL(new Blob([response.data], {
          type: 'text/csv'
        }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'entries.csv');
        document.body.appendChild(link);
        link.click();
      }).catch(function () {
        _this13.$q.loading.hide();

        _this13.$q.notify(_this13.$t('components.entries.error_exporting_file', {
          el: _this13.$t('files.csv')
        }));
      });
    },
    exportPDF: function exportPDF() {
      var _this14 = this;

      var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$q.loading.show();
      this.$axios.post('entries/export-data', _objectSpread({}, this.getExportParams(selected, 'pdf')), {
        headers: {
          Accept: 'application/json,application/pdf,text/plain,*/*'
        },
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this14.$q.loading.hide();

        var url = URL.createObjectURL(new Blob([response.data], {
          type: 'application/pdf'
        }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'entries.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch(function (error) {
        // Convert error response from arraybuffer to object
        var reader = new FileReader();

        reader.onload = function () {
          var _errorResponse$messag;

          var errorResponse = JSON.parse(reader.result);

          _this14.$q.notify({
            message: (_errorResponse$messag = errorResponse.message) !== null && _errorResponse$messag !== void 0 ? _errorResponse$messag : _this14.$t('components.entries.error_generating_pdf'),
            type: 'negative'
          });
        };

        reader.readAsText(new Blob([error.response.data], {
          type: 'application/json'
        }));
      }).finally(function () {
        _this14.$q.loading.hide();
      });
    },
    gotoReport: function gotoReport() {
      // if the current route name is not report, then redirect to report
      if (this.$route.path !== '/reports/entries') {
        this.$router.push({
          path: '/reports/entries',
          query: this.filters
        }).catch(function () {});
      } else {
        this.$router.push({
          query: this.filters
        }).catch(function () {});
      }
    },
    dateValidation: function dateValidation(val) {
      if (val) {
        var regExp;

        switch (this.me.settings.dateFormat) {
          case 'yyyy-mm-dd':
          case 'yyyy/mm/dd':
          case 'yyyy.mm.dd':
            regExp = /^[\d]{4}(\/|\.|-)(0[1-9]|1[0-2])(\/|\.|-)([0-2][0-9]|3[0-1])$/;
            break;

          case 'dd-mm-yyyy':
          case 'dd/mm/yyyy':
          case 'dd.mm.yyyy':
            regExp = /^([0-2][0-9]|3[0-1])(\/|\.|-)(0[1-9]|1[0-2])(\/|\.|-)[\d]{4}$/;
            break;

          case 'mm-dd-yyyy':
          case 'mm/dd/yyyy':
          case 'mm.dd.yyyy':
            regExp = /^(0[1-9]|1[0-2])(\/|\.|-)([0-2][0-9]|3[0-1])(\/|\.|-)[\d]{4}$/;
            break;
        }

        return regExp.test(val) || this.$t('validation.validData');
      }
    },
    getEntriesCount: function getEntriesCount() {
      var _this15 = this;

      this.$axios.post('/entries/get-stats', this.sanitizeFilters(this.filters)).then(function (response) {
        _this15.entriesStats = response.data;
      }).catch(function () {});
    },
    onScroll: function onScroll(_ref) {
      var verticalPosition = _ref.verticalPosition,
          verticalSize = _ref.verticalSize,
          verticalContainerSize = _ref.verticalContainerSize;
      var requestStatus = this.$store.state.entities.entries.pending;

      if (!requestStatus && verticalSize - verticalPosition < 2 * verticalContainerSize && this.entries.length < this.totalEntries) {
        this.loadEntries(this.page + 1);
      }
    },
    loadEntries: function loadEntries(page) {
      var _this16 = this;

      // TODO add check on last page to avoid infinite calling
      this.loading = true;

      if (!page || page <= this.page || isObject(page)) {
        this.overwrite = true;
      }

      var requestStatus = this.$store.state.entities.entries.pending;

      if (!requestStatus) {
        Entry.commit(function (state) {
          state.pending = true;
        });
        Entry.api().post('/get-entries', _objectSpread(_objectSpread({}, this.sanitizeFilters(this.filters)), {}, {
          page: page !== null && page !== void 0 ? page : 1,
          per_page: 50,
          sort_by: this.me.account.hasFeature('from_to') ? 'entry_time_from' : 'entry_date'
        }), {
          save: false
        }).then(function (result) {
          Entry.commit(function (state) {
            state.pending = false;
          });

          var fromToEnabled = _this16.me.account.hasFeature('from_to'),
              entries = result.response.data.data.map(function (entry) {
            return _objectSpread(_objectSpread({}, entry), {}, {
              selected: false,
              time_from: moment(entry.time_from).isValid() || !fromToEnabled ? entry.time_from : moment(entry.date + ' 09:00:00').format('YYYY-MM-DD HH:mm:ss'),
              time_to: moment(entry.time_to).isValid() || !fromToEnabled ? entry.time_to : moment(entry.date + ' 09:00:00').add(entry.entry_minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss')
            });
          });

          if (result.response.data.current_page > _this16.page) {
            _this16.entries = [].concat(_toConsumableArray(_this16.entries), _toConsumableArray(entries));
          } else {
            _this16.entries = _toConsumableArray(entries);
          } // order the entries after removing any duplicates


          _this16.entries = orderBy(uniqBy(_this16.entries, 'entry_id'), [fromToEnabled ? 'entry_time_from' : 'entry_date', 'entry_id'], ['desc', 'desc']);
          _this16.totalEntries = result.response.data.total;
          _this16.page = result.response.data.current_page;
          _this16.loading = false;
          _this16.overwrite = false;

          if (_this16.page === 1) {
            _this16.getEntriesCount();
          }
        }).catch(function (e) {
          console.error(e);
          Entry.commit(function (state) {
            state.pending = false;
          });
        });
      }
    },
    confirmUpdateEntries: function confirmUpdateEntries() {
      var _this17 = this;

      var params = this.sanitizeFilters(this.updatedParams);
      var changes = [];

      if (params.delete_selected) {
        changes.push('<li class="text-negative">' + this.$t('components.entries.delete_selected_entries') + '</li>');
      } else {
        Object.keys(params).forEach(function (param) {
          if (params[param] !== null) {
            if (param === 'member_id') {
              var owner = User.query().find(params.member_id).name;
              changes.push("<li>Set owner: <strong>".concat(owner, "</strong></li>"));
              changes.push("<li>".concat(_this17.$t('components.entries.set_owner'), ": <strong>").concat(owner, "</strong></li>"));
            }

            if (param === 'project_id') {
              var project = Project.query().find(params.project_id).name;
              changes.push("<li>".concat(_this17.$t('components.entries.set_project'), ": <strong>").concat(project, "</strong></li>"));
            }

            if (param === 'phase_id') {
              var phase = Phase.query().find(params.phase_id).name;
              changes.push("<li>".concat(_this17.$t('components.entries.set_phase'), ": <strong>").concat(phase, "</strong></li>"));
            }

            if (param === 'date') {
              changes.push("<li>".concat(_this17.$t('components.entries.set_date'), ": <strong>").concat(Vue.filter('dateFormat')(params.date), "</strong></li>"));
            }

            if (param === 'hourly_rate') {
              changes.push("<li>".concat(_this17.$t('general.set_hourly_rate'), ": <strong>").concat(Vue.filter('currency')(params.hourly_rate), "/h</strong></li>"));
            }

            if (param === 'hourly_cost') {
              changes.push("<li>".concat(_this17.$t('general.set_hourly_cost'), ": <strong>").concat(Vue.filter('currency')(params.hourly_cost), "/h</strong></li>"));
            }

            if (param === 'billed_status') {
              var status = '';

              switch (params.billed_status) {
                case 0:
                  status = _this17.$t('general.unbilled');
                  break;

                case 1:
                  status = _this17.$t('general.billed');
                  break;

                case 2:
                  status = _this17.$t('general.not_billable');
                  break;

                default:
                  break;
              }

              changes.push("<li>".concat(_this17.$t('components.entries.set_billed_status'), ": <strong>").concat(status, "</strong></li>"));
            }
          }
        });
      }

      changes = changes.reduce(function (acc, val) {
        return acc + val;
      }, '');
      this.openDialog('UserConfirmationDialog', {
        type: 'warning',
        icon: 'fal:briefcase',
        title: this.$t('components.entries.update_entries'),
        html: true,
        message: this.$t('components.entries.user_confirmation_dialog', {
          sanitized_length: this.sanitizedSelectedEntries.length,
          element: this.$tc('general.entry', this.sanitizedSelectedEntries.length).toLowerCase(),
          changes_length: changes.length ? changes : this.$t('components.entries.no_changes')
        }),
        onConfirm: this.updateEntries
      });
    },
    updateEntries: function updateEntries() {
      var _this18 = this;

      this.loading = true;
      Entry.api().post('/entries/update', _objectSpread(_objectSpread({}, this.sanitizeFilters(this.updatedParams)), {}, {
        entry_ids: this.sanitizedSelectedEntries
      })).then(function (result) {
        _this18.loading = false;
        _this18.selectionData = [];

        _this18.loadEntries();
      }).catch(function () {
        _this18.loading = false;
      });
    },
    sanitizeFilters: function sanitizeFilters(filters) {
      var newFilters = cloneDeep(filters);

      if (newFilters.date_from) {
        // check if newFilters.date_from is in format yyyy-mm-dd
        if (moment(newFilters.date_from, 'YYYY-MM-DD', true).isValid()) {
          newFilters.date_from = moment(newFilters.date_from).format('YYYY-MM-DD');
        } else if (newFilters.date_from.replace(/_/g, '').length === 10) {
          newFilters.date_from = moment(newFilters.date_from, this.dateFormat).format('YYYY-MM-DD');
        } else {
          delete newFilters.date_from;
        }
      } else {
        delete newFilters.date_from;
      }

      if (newFilters.date_to) {
        if (moment(newFilters.date_to, 'YYYY-MM-DD', true).isValid()) {
          newFilters.date_to = moment(newFilters.date_to).format('YYYY-MM-DD');
        } else if (newFilters.date_to.replace(/_/g, '').length === 10) {
          newFilters.date_to = moment(newFilters.date_to, this.dateFormat).format('YYYY-MM-DD');
        } else {
          delete newFilters.date_to;
        }
      } else {
        delete newFilters.date_to;
      }

      if (newFilters.date) {
        if (moment(newFilters.date, 'YYYY-MM-DD', true).isValid()) {
          newFilters.date = moment(newFilters.date).format('YYYY-MM-DD');
        } else if (newFilters.date.replace(/_/g, '').length === 10) {
          newFilters.date = moment(newFilters.date, this.dateFormat).format('YYYY-MM-DD');
        } else {
          delete newFilters.date;
        }
      }

      if (newFilters.user_ids) {
        newFilters.member_ids = newFilters.user_ids;
      }

      if (newFilters.task_ids) {
        newFilters.phase_ids = newFilters.task_ids;
      }

      if (newFilters.task_category_ids) {
        newFilters.category_ids = newFilters.task_category_ids;
      }

      if (newFilters.is_billable) {
        newFilters.billed_status = newFilters.is_billable;
      }

      if (!newFilters.account_id) {
        newFilters.account_id = this.me.account.account_id;
      }

      if (newFilters.tag_ids && typeof newFilters.tag_ids === 'number') {
        newFilters.tag_ids = [newFilters.tag_ids];
      }

      if (newFilters.todo_ids && typeof newFilters.todo_ids === 'number') {
        newFilters.todo_ids = [newFilters.todo_ids];
      }

      if (newFilters.todo_ids && typeof newFilters.todo_ids === 'number') {
        newFilters.todo_ids = [newFilters.todo_ids];
      }

      if (newFilters.hourly_cost === '') {
        newFilters.hourly_cost = null;
      }

      if (newFilters.hourly_rate === '') {
        newFilters.hourly_rate = null;
      }

      return newFilters;
    },
    getExportParams: function getExportParams(selected, format) {
      var params = {};

      if (selected === false) {
        params = _objectSpread(_objectSpread({}, this.sanitizeFilters(this.filters)), {}, {
          format: format
        });
      } else {
        params = {
          entry_ids: this.sanitizedSelectedEntries,
          format: format
        };
      }

      return params;
    },
    addToSelectionData: function addToSelectionData(entry) {
      this.selectionData.push({
        time: entry.entry_minutes,
        entryId: entry.entry_id,
        userId: entry.user_id,
        projectId: entry.project.project_id,
        isBillable: entry.project.is_billable
      });
    },
    updateSelected: function updateSelected(selected, toggledEntry) {
      var _this19 = this;

      var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.updatedParams.delete_selected = false;

      if (selected) {
        if (parent) {
          toggledEntry.entryGroup.forEach(function (entry) {
            var myEntry = _this19.entries.find(function (e) {
              return e.entry_id === entry.entry_id;
            });

            myEntry.selected = selected;

            _this19.addToSelectionData(myEntry);
          });
        } else {
          var myEntry = this.entries.find(function (e) {
            return e.entry_id === toggledEntry.entry_id;
          });
          myEntry.selected = selected;
          this.addToSelectionData(toggledEntry);
        }
      } else {
        if (parent) {
          toggledEntry.entryGroup.forEach(function (entry) {
            var myEntry = _this19.entries.find(function (e) {
              return e.entry_id === entry.entry_id;
            });

            myEntry.selected = selected;

            _this19.selectionData.splice(findIndex(_this19.selectionData, {
              entryId: entry.entry_id
            }), 1);
          });
        } else {
          var _myEntry = this.entries.find(function (e) {
            return e.entry_id === toggledEntry.entry_id;
          });

          _myEntry.selected = selected;
          this.selectionData.splice(findIndex(this.selectionData, {
            entryId: toggledEntry.entry_id
          }), 1);
        }

        if (this.updatedParams.billed_status !== null && !this.hasSelectedBillableEntries) {
          this.updatedParams.billed_status = null;
        }
      }
    },
    onChange: function onChange(entry) {
      var index = findIndex(this.entries, ['entry_id', entry.entry_id]);

      if (index >= 0) {
        this.$set(this.entries, index, entry);
      }
    },
    onDelete: function onDelete(entry) {
      var index = findIndex(this.entries, ['entry_id', entry.entry_id]);

      if (index >= 0) {
        this.$delete(this.entries, index);
        this.totalEntries--;
      }
    },
    showChildrenForEntry: function showChildrenForEntry(entry) {
      if (entry.entryGroup) {
        if (this.visibleChildrenEntryIds.includes(entry.entry_id)) {
          this.visibleChildrenEntryIds = this.visibleChildrenEntryIds.filter(function (id) {
            return id !== entry.entry_id;
          });
        } else {
          this.visibleChildrenEntryIds.push(entry.entry_id);
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.filters.time_frame !== 'all') {
      this.search();
    } else {
      this.loadEntries();
    }
  }
};